import { GridColumnModel } from '../column';

export default class GridColumnPicker<T> {
    constructor() { }

    pick(columns: Array<GridColumnModel<T>>): GridColumnModel<T> | undefined {
        return _(columns).sortBy(column => column.height())[0];
    }
}